import React, { Fragment } from 'react';
import { logoutRtsUser } from './rts-login-helper';
import SvgLogout from '../../../play-core/icons/Logout';
import SvgPlaylist from '../../../play-core/icons/Playlist';
import SvgSettings from '../../../play-core/icons/Settings';
import SvgSwitch from '../../../play-core/icons/Switch';
import { PlayTransparentLink } from '../components/ClickableComponents/PlayLink';
import { RTSLoginProfile } from '../components/Header/HeaderMenu/RTSLoginProfile';
import { MenuDivider } from '../components/Menu/Menu.styles';
import { MenuButton } from '../components/Menu/MenuButton';
import { jsx as _jsx } from "react/jsx-runtime";
const iconMap = {
  Logout: /*#__PURE__*/_jsx(SvgLogout, {}),
  Playlist: /*#__PURE__*/_jsx(SvgPlaylist, {}),
  SwitchSection: /*#__PURE__*/_jsx(SvgSwitch, {}),
  Settings: /*#__PURE__*/_jsx(SvgSettings, {})
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export const renderEntries = (entries, analytics, dispatch) => {
  const actionMap = {
    Logout: () => {
      logoutRtsUser();
      dispatch({
        type: 'set-logged-in',
        isLoggedIn: false
      });
    },
    ShowPrivacySettings: () => {
      window.UC_UI?.showSecondLayer();
    }
  };
  return entries.map((entry, index) => {
    switch (entry.type) {
      case 'Divider':
        return /*#__PURE__*/_jsx(MenuDivider, {}, index);
      case 'Link':
        return /*#__PURE__*/_jsx(PlayTransparentLink, {
          rel: entry.rel,
          to: entry.url,
          text: entry.title,
          fontSize: {
            mediaQuery: [],
            default: 14
          },
          showDefaultIcon: entry.showDefaultIcon,
          icon: entry.icon && iconMap[entry.icon],
          iconPositionRight: false,
          leftAligned: true,
          onClick: () => {
            analytics({
              type: 'click-event',
              name: 'KebabMenuClick',
              value1: entry.title,
              value2: entry.url
            });
          }
        }, entry.title);
      case 'Button':
        return /*#__PURE__*/_jsx(MenuButton, {
          fontSize: {
            mediaQuery: [],
            default: 14
          },
          title: entry.title,
          icon: entry.icon && iconMap[entry.icon],
          onClick: () => {
            entry.onClick && actionMap && actionMap[entry.onClick]();
            analytics({
              type: 'click-event',
              name: 'KebabMenuClick',
              value1: entry.title
            });
          }
        }, entry.title);
      case 'RTSLoginProfile':
        return /*#__PURE__*/_jsx(RTSLoginProfile, {}, index);
      default:
        return /*#__PURE__*/_jsx(Fragment, {});
    }
  });
};